import axios from "axios";

// export const BASE_URL = "https://sme-api.brookessoftware.com/api";
export const BASE_URL = "https://api.promixaccounting.com/api";

// Initialize global axios defaults from localStorage when available
if (typeof window !== 'undefined') {
  try {
    const token = localStorage.getItem('authToken');
    const cid = localStorage.getItem('activeCompanyId') || localStorage.getItem('company_id');
    let sid = localStorage.getItem('activeStoreId') || localStorage.getItem('store_id');
    if (!sid) {
      try {
        const ud = localStorage.getItem('userData');
        if (ud) {
          const parsed = JSON.parse(ud);
          sid = parsed?.store_id || parsed?.default_store_id || parsed?.store?.id || parsed?.company?.store_id || sid;
        }
      } catch (e) {}
    }
    if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    if (cid) axios.defaults.headers.common['company_id'] = String(cid);
    if (sid) axios.defaults.headers.common['store_id'] = String(sid);
  } catch (e) {
    // ignore
  }
}

export function withCompanyId(data) {
  try {
    const cid = (typeof window !== "undefined" && (localStorage.getItem("activeCompanyId") || localStorage.getItem("company_id"))) || null;
    let sid = (typeof window !== "undefined" && (localStorage.getItem("activeStoreId") || localStorage.getItem("store_id"))) || null;

    // fallback: try to extract store_id from stored userData if present
    if (!sid && typeof window !== "undefined") {
      try {
        const ud = localStorage.getItem('userData');
        if (ud) {
          const parsed = JSON.parse(ud);
          sid = parsed?.store_id || parsed?.default_store_id || parsed?.store?.id || parsed?.company?.store_id || null;
        }
      } catch (e) {
        // ignore parsing errors
      }
    }

    if (!cid && !sid) return data;

    // FormData: append if missing
    if (typeof FormData !== "undefined" && data instanceof FormData) {
      if (cid && !data.get("company_id")) data.append("company_id", String(cid));
      if (sid && !data.get("store_id")) data.append("store_id", String(sid));
      return data;
    }

    // Plain object: merge if missing
    if (data && typeof data === "object" && !Array.isArray(data)) {
      const out = { ...data };
      if (cid && out.company_id === undefined) out.company_id = String(cid);
      if (sid && out.store_id === undefined) out.store_id = String(sid);
      return out;
    }
  } catch (e) {
    console.error("withCompanyId helper error", e);
  }
  return data;
}

export function getAuthHeaders(extra = {}) {
  try {
    const token = (typeof window !== "undefined") ? localStorage.getItem("authToken") : null;
    const company = (typeof window !== "undefined") ? (localStorage.getItem("activeCompanyId") || localStorage.getItem("company_id")) : null;
    const store = (typeof window !== "undefined") ? (localStorage.getItem("activeStoreId") || localStorage.getItem("store_id")) : null;
    const headers = {
      Accept: "application/json",
      ...extra,
    };
    if (token) headers.Authorization = `Bearer ${token}`;
    if (company) headers.company_id = String(company);
    if (store) headers.store_id = String(store);
    return headers;
  } catch (e) {
    console.error("getAuthHeaders error", e);
    return { ...extra };
  }
}

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
  },
});

api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("authToken");
    const companyId = localStorage.getItem("activeCompanyId") || localStorage.getItem("company_id");
    const storeId = localStorage.getItem("activeStoreId") || localStorage.getItem("store_id");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (companyId && config.headers.company_id === undefined) {
      config.headers.company_id = String(companyId);
    }
    if (storeId) {
      config.headers.store_id = String(storeId);
    }
    // Ensure GET requests include company/store IDs as query params too
    try {
      const method = (config.method || '').toLowerCase();
      if (method === 'get') {
        config.params = config.params || {};
        if (companyId && config.params.company_id === undefined) config.params.company_id = String(companyId);
        if (storeId && config.params.store_id === undefined) config.params.store_id = String(storeId);
      }
    } catch (e) {
      // ignore param attach errors
    }
  } catch (e) {
    // ignore errors accessing localStorage
  }
  return config;
});

export default api;
